export const chatThemes = {
  default: {
    name: 'Default',
    background: 'bg-gray-50 dark:bg-gray-900',
    bubbleSent: 'bg-blue-500 text-white',
    bubbleReceived: 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white',
  },
  ocean: {
    name: 'Ocean',
    background: 'bg-gradient-to-b from-blue-50 to-cyan-50 dark:from-blue-900 dark:to-cyan-900',
    bubbleSent: 'bg-cyan-500 text-white',
    bubbleReceived: 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm',
  },
  sunset: {
    name: 'Sunset',
    background: 'bg-gradient-to-b from-orange-50 to-pink-50 dark:from-orange-900 dark:to-pink-900',
    bubbleSent: 'bg-orange-500 text-white',
    bubbleReceived: 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm',
  },
  forest: {
    name: 'Forest',
    background: 'bg-gradient-to-b from-green-50 to-emerald-50 dark:from-green-900 dark:to-emerald-900',
    bubbleSent: 'bg-emerald-500 text-white',
    bubbleReceived: 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm',
  },
  purple: {
    name: 'Purple',
    background: 'bg-gradient-to-b from-purple-50 to-violet-50 dark:from-purple-900 dark:to-violet-900',
    bubbleSent: 'bg-purple-500 text-white',
    bubbleReceived: 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm',
  },
};

export type ChatTheme = keyof typeof chatThemes;

export const getTheme = (themeName: ChatTheme) => {
  return chatThemes[themeName] || chatThemes.default;
};

export const themeNames = Object.keys(chatThemes) as ChatTheme[];